import { HttpClientService } from "./HttpClientService.ts";

export class HttpService extends HttpClientService {
  customProperty;

  constructor() {
    super(process.env.REACT_APP_Server_Url || "");
  }
}
